export var EndUserAnalyticEventTypes;
(function (EndUserAnalyticEventTypes) {
    EndUserAnalyticEventTypes["PORTAL_PAGE_VIEW"] = "PORTAL_PAGE_VIEW";
    EndUserAnalyticEventTypes["STATEMENT_DOWNLOAD"] = "STATEMENT_DOWNLOAD";
})(EndUserAnalyticEventTypes || (EndUserAnalyticEventTypes = {}));
export var EndUserAnalyticEventResource;
(function (EndUserAnalyticEventResource) {
    EndUserAnalyticEventResource["INVOICE"] = "INVOICE";
    EndUserAnalyticEventResource["STATEMENT"] = "STATEMENT";
    EndUserAnalyticEventResource["QUOTE"] = "QUOTE";
})(EndUserAnalyticEventResource || (EndUserAnalyticEventResource = {}));
//# sourceMappingURL=endUserAnalyticEvent.js.map